import React, { useEffect, useState } from "react";
import "./CookieConsent.css";

type CookiePreferences = {
    essential: boolean;
    analytics: boolean;
    marketing: boolean;
};

const defaultPreferences: CookiePreferences = {
    essential: true, // always true
    analytics: false,
    marketing: false,
};

const CookieConsent: React.FC = () => {
    const [visible, setVisible] = useState(false);
    const [preferences, setPreferences] = useState<CookiePreferences>(defaultPreferences);
    const [showSettings, setShowSettings] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem("cookiePreferences");
        if (!consent) {
            setVisible(true);
        }
    }, []);

    const handleSavePreferences = () => {
        localStorage.setItem("cookiePreferences", JSON.stringify(preferences));
        setVisible(false);
    };

    const handleAcceptAll = () => {
        const allPrefs: CookiePreferences = {
            essential: true,
            analytics: true,
            marketing: true,
        };
        localStorage.setItem("cookiePreferences", JSON.stringify(allPrefs));
        setVisible(false);
    };

    const handleToggle = (type: keyof CookiePreferences) => {
        if (type === "essential") return; // Always true
        setPreferences((prev) => ({ ...prev, [type]: !prev[type] }));
    };

    if (!visible) return null;

    return (
        <div className="cookie-popup">
            <p>
                We use cookies to improve your experience.{" "}
                <a href="/privacy" target="_blank" rel="noopener noreferrer">
                    Learn more
                </a>
            </p>

            {showSettings ? (
                <>
                    <div className="cookie-toggle">
                        <label>
                            <input type="checkbox" checked disabled /> Essential (Always On)
                        </label>
                        <label>
                            <input
                                type="checkbox"
                                checked={preferences.analytics}
                                onChange={() => handleToggle("analytics")}
                            />{" "}
                            Analytics
                        </label>
                        <label>
                            <input
                                type="checkbox"
                                checked={preferences.marketing}
                                onChange={() => handleToggle("marketing")}
                            />{" "}
                            Marketing
                        </label>
                    </div>
                    <div className="cookie-buttons">
                        <button onClick={handleSavePreferences}>Save Preferences</button>
                        <button onClick={handleAcceptAll}>Accept All</button>
                    </div>
                </>
            ) : (
                <div className="cookie-buttons">
                    <button onClick={() => setShowSettings(true)}>Set Preferences</button>
                    <button onClick={handleAcceptAll}>Accept All</button>
                </div>
            )}
        </div>
    );
};

export default CookieConsent;
